module.exports = __webpack_public_path__ + "static/featured-shoe-16db5b4aa681296717d1b6745f39cf38.png";